// Which autopay enrolments a newly added card will be applied to, from the "Add / Replace / Change
// card" dialog. Kept pure so every page that opens the dialog (Autopay tab, account profile,
// booking detail, booking list card, the Stripe return) shares one rule.

// A failed charge being retried on the card already on file.
export const isRetrying = (s: any) => (Number(s?.retryState?.failCount) || 0) > 0 && s?.status === "active" && !s?.needsAttention;

// An enrolment a new card would rescue: waiting for its first card, or bound to one that is failing.
// A subscription paying happily on a different card is deliberately NOT one of these.
export const needsACard = (s: any) => !!s?.autopayEnrolled
  && (s.status === "pending_setup" || (s.status === "active" && (s.needsAttention || isRetrying(s))));

/**
 * `fixing` is the enrolment whose button opened the dialog. It always gets the card — including a
 * healthy one the payer chose "Change card" on, which is not "broken" and used to be left out.
 * "Also use this card for my other bookings" adds every other enrolment that needs a card; one
 * paying happily on a different card is never pulled in unless it is the one being changed.
 */
export function getCardScope(subs: any[], fixing: any, applyToAll: boolean) {
  const otherBroken = (subs || []).filter((s) => needsACard(s) && s.id !== fixing?.id);
  const inScope = fixing ? [fixing, ...(applyToAll ? otherBroken : [])] : [];
  const inScopeIds = new Set(inScope.map((s) => s.id));
  const untouched = (subs || []).filter((s) => s.status !== "cancelled" && !inScopeIds.has(s.id));
  return { inScope, untouched, otherBroken };
}
